import React from 'react';
import styles from '@buddieshr/styles/components/marketingBanner.module.scss';

const MarketingBanner = ({ content }) => {
  return <div className={styles.MarketingBanner_wrapper}>{content}</div>;
};

export default MarketingBanner;
